import React from 'react';
import { Box } from '@mui/material';
import { RightSidebarViewer } from 'features/viewing';

type SideSummaryDisplayProps = {
  open: boolean;
  highlights: Array<any>;
  selectedHighlight: any;
  scrollToHighlight: (highlight: any) => void;
  viewerControl: any;
  fileData: any;
  gridView: boolean;
  isAiTab: boolean;
};

const SideSummaryDisplay = ({
  open,
  selectedHighlight,
  highlights,
  scrollToHighlight,
  fileData,
  viewerControl,
  gridView,
  isAiTab
}: SideSummaryDisplayProps) => {

  if (!open) return null;
  return (
    <>
      <Box
        sx={{
          position: 'relative',
          top: 0,
          right: 0,
          width: isAiTab? '23vw' : '35vw',
          height: '100%',
          backgroundColor: 'background.paper',
          borderLeft: '1px solid #E5E5E5',
          display: 'flex',
          flexDirection: 'column',
          transition: 'width 1s ease-out',
        }}
      >
          <div
            style={{
              paddingLeft: '2px',
              height: 'calc(100vh - 1rem)',
              position: 'relative',
            }}
          >
            <RightSidebarViewer
              selectedHighlight={selectedHighlight}
              highlights={highlights}
              scrollToHighlight={scrollToHighlight}
              fileData={fileData}
              viewerControl={viewerControl}
              gridView={gridView}
            />
          </div>
      </Box>
    </>
  );
};

export default SideSummaryDisplay;
